<template>
  <div style="background:#F0F0F0">
    <div class="common_banner">
      <i class="user_icon" ref="iconuser"></i>
      <h3 class="user_title">{{ this.userdata.mobile }}</h3>
      <p class="user_time" ref="icontime">
        充值有效期:{{ this.userdata.deadtime ? this.userdata.deadtime : "无"
        }}<span @click="goBuy" class="goBuy">优惠续费</span>
      </p>
      <button class="mobile_btn" @click="userout">退出</button>
    </div>
    <div class="container">
      <div class="container-left" v-if="!this.$store.state.ShowSubContainer">
        <div class="left_btn">
          <span @click="changetab(0)" :class="{ active: tabstatus === 0 }"
            >账户管理</span
          >
          <span @click="changetab(4)" :class="{ active: tabstatus === 4 }"
            >实名认证</span
          >
          <span @click="changetab(1)" :class="{ active: tabstatus === 1 }"
            >充值记录</span
          >
          <span
            @click="changetab(2)"
            :class="{ active: tabstatus === 2, smallHide: true }"
            >发票管理</span
          >
          <span @click="goBuy">优惠购买</span>
          <span @click="changetab(3)" :class="{ active: tabstatus === 3 }"
            >我的优惠券</span
          >
          <span @click="changetab(5)" :class="{ active: tabstatus === 5 }"
            >独享节点管理</span
          >
        </div>
      </div>
      <div class="container-right" v-if="!this.$store.state.ShowSubContainer">
        <div class="management" v-if="tabstatus == '0'">
          <h2>账户管理</h2>
          <div class="item">
            <span>用户名</span>
            <span>{{ this.userdata.mobile }}</span>
            <span
              v-clipboard:copy="this.userdata.mobile"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              >复制</span
            >
          </div>
          <div class="item">
            <span>实名认证</span>
            <span>{{ cert_status() }}</span>
            <span @click="changetab(4)" v-if="cert_status() == '暂未认证'"
              >去认证</span
            >
          </div>
          <div class="item">
            <span>登录密码</span>
            <span>已经设置</span>
            <!-- <span @click="xx">修改</span> -->
            <router-link
              tag="span"
              to="/Personal/changepwd"
              @click.native="changeSub"
              >修改</router-link
            >
          </div>
          <div class="item">
            <span>绑定手机</span>
            <span
              >{{
                this.userdata.mobile
                  ? this.formatPhone(this.userdata.mobile)
                  : "未绑定"
              }}
            </span>
            <!-- <span v-if="this.userdata.mobile">修改</span> -->
            <router-link
              tag="span"
              v-if="this.userdata.mobile"
              to="/Personal/changephone"
              @click.native="changeSub"
              >解绑</router-link
            >
            <router-link
              tag="span"
              v-if="!this.userdata.mobile"
              to="/Personal/bindingphone"
              @click.native="changeSub"
              >绑定</router-link
            >
            <!-- <span v-if="!this.userdata.mobile">绑定</span> -->
          </div>
          <div class="item">
            <span>套餐类型</span>
            <span>{{ this.userdata.type ? this.userdata.type : "无" }} </span>
          </div>
          <div class="item">
            <span>到期时间</span>
            <span>{{
              this.userdata.deadtime ? this.userdata.deadtime : "无"
            }}</span>
            <span @click="goBuy">续费</span>
            <!-- <router-link tag="span" to="/Buy">续费</router-link> -->
          </div>
        </div>

        <div class="recording" v-if="tabstatus == '4'">
          <h2>实名认证</h2>
          <id-vertify @loginout="userout"></id-vertify>
        </div>
        <div class="recording" v-if="tabstatus == '1'">
          <h2>充值记录</h2>
          <recharge @gorecharge="gorecharge(1)" @loginout="userout"></recharge>
        </div>
        <div class="recording" v-if="tabstatus == '2'">
          <h2>发票列表</h2>
          <invoice-managent
            @gonvoicemangent="gonvoicemangent(2)"
            @loginout="userout"
          ></invoice-managent>
        </div>
        <div class="recording" v-if="tabstatus == '3'">
          <h2>我的优惠券</h2>
          <coupon-list
            @gocouponlist="gocouponlist(3)"
            @loginout="userout"
          ></coupon-list>
        </div>
        <div class="recording exclusive" v-if="tabstatus == '5'">
          <h2 @click="goExclusiveBuy">前往购买独享专线</h2>
          <exclusiveNodeManagement></exclusiveNodeManagement>
        </div>
      </div>
      <div
        class=""
        style="background:#fff;"
        v-if="this.$store.state.ShowSubContainer"
      >
        <router-view></router-view>
      </div>
    </div>

    <!-- 优惠券弹框 -->
    <Modal v-model="couponModal" class-name="vertical-center-modal" width="340">
      <div class="coupon-bgc">
        <div class="close" @click="closeModal"></div>
        <div class="text" style="color:#803c00;">
          <div>
            <p style="font-size:18px;font-weight: 700;">{{ freeTime }}分钟</p>
            <p style="font-size:14px;">VIP会员体验时长</p>
          </div>
        </div>

        <div class="coupon-detail-box">
          <div
            class="coupon-detail"
            v-for="item in couponInfo"
            :key="item.code"
          >
            <div class="coupon-price">
              <p>
                <span class="rmb">&yen;</span>
                <span class="minus">{{ item.minus_price }}</span>
              </p>
              <p>满{{ item.full_reduction }}元可用</p>
            </div>
            <div class="coupon-name">
              <div class="new-user-bgc">{{ item.user_type }}专享</div>
              <div class="coupon-name-date">
                <p>{{ item.discount_name }}</p>
                <p>
                  {{
                    item.valid_day > 0
                      ? "领取后" + item.valid_day + "内使用"
                      : item.start_date + "~" + item.end_date
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="footer-modal">
          <div>
            <div class="footer_btn" @click="closeModal">开心收下</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
import VueClipboard from "vue-clipboard2";
import recharge from "@/pages/Personal/components/recharge";
import InvoiceManagent from "@/pages/Personal/components/InvoiceManagent";
import couponList from "@/pages/Personal/components/couponList";
import idVertify from "@/pages/Personal/components/idVertify";
import exclusiveNodeManagement from "@/pages/Personal/components/exclusiveNodeManagement";
import Cookies from "js-cookie";
export default {
  name: "Personal",
  data() {
    return {
      tabstatus: 0,
      rightstatus: true,
      userdata: {},
      paperId: "",
      username: "",
      password: "",
      session: "",
      couponModal: false,
      couponInfo: [],
      freeTime: 0,
      usernameCoupon: ""
    };
  },
  components: {
    recharge,
    InvoiceManagent,
    couponList,
    idVertify,
    exclusiveNodeManagement
  },
  mounted() {
    // c++ 用户绑定 专用
    if (window.location.search.indexOf("ok") > 0) {
      this.$store.state.LoginStatus = true;
      this.loadRecharge();
    }

    //2020-7-17
    doPost(
      {
        action: "user_detail",
        username: localStorage.getItem("username"),
        token: localStorage.getItem("session"),
        token2: localStorage.getItem("session")
      },
      res => {
        if (res.user_id) {
          this.userdata = res;
          if (this.userdata.deadtime) {
            this.userdata.deadtime = this.formatDateTime(
              this.userdata.deadtime
            );
          }
          //绑定手机 需缓存（bindingphone）用户邮箱
          // localStorage.useremail = this.userdata.email
          this.usernameCoupon = res.username;
          Cookies.set("useremail", this.userdata.email);
          if (this.userdata.mobile) {
            //解绑手机 需缓存用户手机 （changephone）
            // localStorage.mobile = this.userdata.mobile
            Cookies.set("mobile", this.userdata.mobile);
          }
          if (this.usernameCoupon) {
            // 新用户首次登陆优惠券弹框
            if (!localStorage.getItem("firstTimeLogin")) {
              doPost(
                {
                  action: "new_user_coupon",
                  username: this.usernameCoupon || ""
                },
                res => {
                  if (res.status == 0) {
                    this.couponModal = true;
                    this.freeTime = res.free_time;
                    this.couponInfo = res.list;
                    localStorage.setItem("firstTimeLogin", "true");
                  }
                }
              );
            }
          }
          this.$Loading.finish();
        }
      }
    );

    this.face_switch(); //判断是否要开启人脸认证
  },
  computed: {
    xx() {
      if (!this.tabstatus) {
        if (this.$store.state.ShowSubContainer) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  watch: {
    userdata() {
      if (this.userdata.user_status) {
        this.$refs.iconuser.classList.add("vip");
      }
    },
    paperId() {
      if (this.paperId) {
        this.loadRecharge();
      }
    }
  },
  methods: {
    closeModal() {
      console.log("关闭");
      this.couponModal = false;
    },
    formatPhone(data) {
      let res =
        data.substr(0, 2) + "***" + data.substr(5, data.split("").length);
      return res;
    },
    onCopy() {
      this.$Message.success("您已复制成功");
    },
    onError() {
      this.$Message.error("无法复制，请稍后再尝试");
    },
    loadRecharge() {
      // let username = localStorage.getItem("username")
      // let session = localStorage.getItem("session")
      let username = this.username || Cookies.get("username");
      let session = this.session || Cookies.get("session");
      if (!session) {
        this.$store.commit("changeLogin", false);
        localStorage.removeItem("LoginStatus");
        Cookies.remove("session");
        Cookies.remove("username");
        this.$router.push("/");
        return;
      }
      this.$Loading.start();
      doPost(
        { action: "user_detail", username: username, session: session },
        res => {
          if (res.user_id) {
            this.userdata = res;
            if (this.userdata.deadtime) {
              this.userdata.deadtime = this.formatDateTime(
                this.userdata.deadtime
              );
            }
            //绑定手机 需缓存（bindingphone）用户邮箱
            // localStorage.useremail = this.userdata.email
            Cookies.set("useremail", this.userdata.email);
            if (this.userdata.mobile) {
              //解绑手机 需缓存用户手机 （changephone）
              // localStorage.mobile = this.userdata.mobile
              Cookies.set("mobile", this.userdata.mobile);
            }
            this.$Loading.finish();
          }
        }
      );
    },
    changeSub() {
      this.$store.commit("changeSub", true);
      Cookies.set("userdata", JSON.stringify(this.userdata));
    },
    changetab(val) {
      // if(!v) {
      //     this.tabstatus = false
      // }else{
      //     this.tabstatus = true
      // }
      //2020-7-30修改原有的逻辑
      this.tabstatus = val;
      console.log("this.tabstatus" + this.tabstatus);
    },
    userout() {
      this.$store.commit("changeLogin", false);
      //退出时将从缓存中移除 用户session 登录状态LoginStatus 用户名存储
      localStorage.clear();
      Cookies.remove("session");
      Cookies.remove("LoginStatus");
      Cookies.remove("user_name");
      // this.$router.push("/")
      window.location.href = "/resource/login"; //2020-7-17改
    },
    formatDateTime(timeStamp) {
      var date = new Date();
      date.setTime(timeStamp * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    //2020-7-16
    goBuy() {
      window.open("/buy/");
    },
    goExclusiveBuy() {
      location.href = "/buy/?isExclusive=true";
    },
    staticClick(url) {
      window.location.href = url;
    },
    gorecharge(val) {
      this.tabstatus = val;
      this.$store.state.ShowSubContainer = true;
      this.$router.push("/Personal/invoice");
    },
    gonvoicemangent(val) {
      this.tabstatus = val;
      this.$store.state.ShowSubContainer = true;
      this.$router.push("/Personal/invoicemodify");
    },
    //实名认证状态
    cert_status() {
      if (localStorage.getItem("cert_status") != "") {
        return "认证通过";
      } else {
        return "暂未认证";
      }
    },
    //人脸认证开关
    face_switch() {
      //判断是否要人脸认证
      doPost(
        {
          action: "face_switch"
        },
        res => {
          if (res.status == 0) {
            localStorage.setItem("ali_switch", res.detail.ali_switch);
            localStorage.setItem("weixin_switch", res.detail.weixin_switch);
            localStorage.setItem("three_switch", res.detail.three_switch);
          }
        }
      );
    }
  },
  created() {
    console.log(
      'sessionStorage("openNodeManagement")',
      sessionStorage.getItem("openNodeManagement")
    );
    if (sessionStorage.getItem("openNodeManagement")) {
      sessionStorage.removeItem("openNodeManagement");
      this.changetab(5);
    }
  }
};
</script>

<style lang="stylus" scoped>
@media (max-width: 576px)
    >>>.vertical-center-modal .ivu-modal
      flex 0
>>>.ivu-modal-footer
    display none
>>>.ivu-modal-close
    display none
>>>.ivu-modal-body
    padding 0
>>>.ivu-modal-content
    border-radius 8px
>>>.vertical-center-modal
        display flex;
        align-items center;
        justify-content center;
        .ivu-modal
            top: 0;
.coupon-bgc
    width 340px;
    height 390px;
    padding 65px 20px 0;
    box-sizing border-box;
    position relative;
    background-image url("~@/assets/img/login-coupon-img/TZ/bg.png");
    .close
       width 26px;
       height 26px;
       position absolute;
       top 10px;
       right 10px;

       background-image url("~@/assets/img/login-coupon-img/TZ/gb-nor.png") ;
       background-repeat norepeat;
       &:hover
         cursor pointer;
         background-image url("~@/assets/img/login-coupon-img/TZ/gb-hover.png") ;
    .text
       width 100%;
       height 80px;
       border-radius 8px;
       position: relative;
       margin-bottom 10px
       div
         position absolute;
         top 50%;
         left 50%;
         transform translate(-50%,-50%);
    .coupon-detail-box
        width 100%
        height 176px
        overflow auto
        /* 滚动条 */
        &::-webkit-scrollbar
            width 0px;
            height 0px;
            padding-left 40px
        &::-webkit-scrollbar-thumb
            border-radius 10px;
            background rgba(105, 105, 105, .5)

        &::-webkit-scrollbar-track
            background: rgba(105, 105, 105, .5)
    .coupon-detail
        width 100%;
        height 78px;
        margin-bottom 10px
        display flex
        background-image url("~@/assets/img/login-coupon-img/TZ/coupon-bg.png");
        .coupon-price
          width 98px
          height 100%
          text-align center
          p:nth-child(1)
            padding-top 3px
          .rmb
            font-size 18px
            font-weight bold
            color #ff5c00
          .minus
            font-size 28px
            font-weight bold
            color #ff5c00
        .coupon-name
          flex 1
          height 100%
          position relative
          .new-user-bgc
            width 86px
            height 18px
            position absolute
            right 0
            top 0
            color white
            text-align center
            line-height 18px
            border-radius 0 8px 0 8px
            background-image url("~@/assets/img/login-coupon-img/TZ/new-user.png")
          .coupon-name-date
            position absolute
            top 50%
            left 25%
            transform translate(-20%,-50%)
            p:nth-child(1)
              font-size 16px
              font-weight 600
              color #ff5c00
              margin-bottom 4px
            p:nth-child(2)
              font-size 12px
              color #999999

    .footer-modal
        width 100%;
        height 96px;
        position absolute;
        bottom 0;
        left 0;
        background-image url("~@/assets/img/login-coupon-img/TZ/modal.png");
        &>div
           width 100%
           height 100%
           position relative
           .footer_btn
             width 166px
             height 40px
             text-align center
             line-height 40px
             position absolute;
             top 50%;
             left 50%;
             color #ff4e09
             font-weight 600
             font-size 18px
             cursor pointer
             transform translate(-50%,-52%);
             background-image url("~@/assets/img/login-coupon-img/TZ/but-nor.png")
             &:hover
               background-image url("~@/assets/img/login-coupon-img/TZ/but-hover.png")



.common_banner
    background-image url("~@/assets/img/personal_img/personal_banner.png")
    text-align center
    position relative
.common_banner button
    position absolute
    right 17%
    bottom 109px
    opacity 0.8
    background #666666
    border-radius 2px
    width 84px
    height 36px
    color #ffffff
.common_banner i:nth-child(1)
    width 60px
    display inline-block
    height 60px
    background url("~@/assets/img/personal_img/icon_notvip.png")
    margin-top 40px
.common_banner i.vip
    background url("~@/assets/img/personal_img/icon_vip.png")
.common_banner .user_title
    padding 16px 0px
.common_banner .goBuy
    cursor: pointer;
    color: #19be6b;
    margin-left: 20px;
.container
    width 1200px
    margin 0 auto
    padding 45px 0px 49px 0px
    font-family MicrosoftYaHei
    &:after
        content ''
        display block
        height 0px
        clear both
.container .container-left
    width 184px
    height 600px
    background #ffffff
    float left
.container .container-left  .left_btn
    margin-top 10px
    &:after
    	content ''
    	display block
    	height 0px
    	clear both
.container .container-left  .left_btn span
    display block
    width 144px
    height 39px
    margin 0 auto
    line-height 39px
    text-align left
    padding-left 20px
    cursor pointer
.container .container-left .left_btn span.active
  background #19be6b
  color #ffffff
.container .container-left  .left_btn span:hover
    background #19be6b
    color #ffffff
.container .container-right
    width 1000px
    min-height 600px
    padding-bottom 20px
    background #ffffff
    float left
    margin-left 16px
.management,.recording
    padding 0px 30px
.management h2,.recording h2
    padding 16px 5px 0px 5px
    font-size 18px
    color #19be6b
    margin-bottom 15px

.exclusive
    padding-top 20px
    box-sizing border-box

.exclusive h2
    width 150px
    height 27px
    font-size 14px
    line-height 27px
    background url('~@/assets/img/personal_img/icon_anniu.png')
    background-repeat no-repeat
    padding 0
    background-size cover
    text-indent 5px
    color #fff
    cursor pointer
    margin-left -30px

.management .item
    padding 20px 20px
    border-bottom 1px solid #eeeeee
    cursor pointer
.management .item span:nth-child(2)
    padding-left 20px
.management .item span:nth-child(3)
    float right
    font-size 14px
    color #2BD3A0
 @media screen and (max-width: 1200px)
    .container
        width 100%
    .container .container-left,.container .container-right
        float none
    .container .container-left
        height auto
        width 100%
    .container .container-left .left_btn
        margin-top 0rem
    .container .container-left .left_btn span
        padding-left 0px
        float left
        text-align center
        width 25%
        height 1rem
        line-height 1rem
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
    .container .container-right
        margin-left 0px
        width 100%
    .container .container-left .left_btn span.smallHide
        display none
@media screen and (max-width: 768px)
    .container
        padding-top 0px
        .container-left
            padding-top 10px
    .management, .recording
        padding 10px 20px 0;
    .exclusive h2
        margin-left -20px
@media screen and (max-width: 456px)
    .common_banner button
        left 50%
        margin-left -34px
        width 68px
        height 24px
        bottom: 6px;
    .management, .recording
        padding  10px 5px 0
    .exclusive h2
        margin-left -5px
.scrollba::-webkit-scrollbar
	width 10px
.scrollba::-webkit-scrollbar-track
  background rgba(0,0,0,0.2)
  border-radius 10px
.scrollba::-webkit-scrollbar-thumb
  background #007AFF
  border-radius 10px
</style>



// WEBPACK FOOTER //
// src/pages/Personal/Personal.vue